module.exports = __webpack_public_path__ + "img/era_device_large.6e92313c.webp";